import { gql } from '@apollo/client'

const REDEEM_DISCOUNT_MUTATION = gql`
  mutation RedeemDiscount($userId: ID!, $discountCode: String!) {
    redeemReactivationDiscount(
      userId: $userId
      discountCode: { code: $discountCode }
    ) {
      id
      subscription {
        id
        alreadyRedeemedReactivationCampaign {
          name
          expiryDate
          description
          discountCode {
            id
            discountCodeParts {
              discountBasis
              value
              discountType
              n
            }
          }
        }
        previewUncreatedFutureBox {
          isoDeliveryDate
          order {
            id
            totalPrice
            surchargeTotal
            planTotal
            deliveryFee
            subtotal
            discountTotal
            discountedSubtotalPricePerDay
            subtotalPricePerDay
          }
        }
      }
    }
  }
`

export { REDEEM_DISCOUNT_MUTATION }
